export const enum TerminalType {
  _unknown = 0,
  _h5 = 1,
  _web = 2,
  _android = 3,
  _ios = 4
}
